import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { CreateCourseData } from "../components";

type Props = {};

const CreateCourseContainer = (props: Props) => {
  return (
    <AppLayout>
      <CreateCourseData />
    </AppLayout>
  );
};

export default CreateCourseContainer;
